
export interface GetSortTypesInput {
    warehouseId: string;
    associate: string;
    locale: string;
}

export interface GetSortTypesOutput {
    validSortTypes: string[];
}

export const buildGetSortTypesInput = (warehouseId: string, associate: string,
                                       locale: string): GetSortTypesInput => {
    return {
        warehouseId,
        associate,
        locale
    }
}